module.exports = __webpack_public_path__ + "static/media/icon_SPclients.acddf771.png";